import * as React from 'react';
import { FilterRow } from '@/components/custom/filter';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { SearchIcon } from 'lucide-react';

const FilterInput = React.forwardRef(({ label, endIcon: EndIcon, type, id, fullWidth, ...props }, ref) => {
  const compId = React.useId();
  const IconToRender = EndIcon || (type === 'search' ? SearchIcon : null);
  const hasEndIcon = !!IconToRender;

  return (
    <FilterRow
      ref={ref}
      className={fullWidth ? 'md:w-full' : null}
    >
      {label && <Label htmlFor={id ?? compId}>{label}</Label>}
      <div className="relative">
        <Input
          id={id ?? compId}
          className="peer"
          type={type}
          endIcon={hasEndIcon}
          {...props}
        />
        {hasEndIcon && (
          <div className="pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-neutral peer-disabled:opacity-50 [&_svg]:size-4">
            <IconToRender aria-hidden="true" />
          </div>
        )}
      </div>
    </FilterRow>
  );
});
FilterInput.displayName = 'FilterInput';

export { FilterInput };
